var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99993,
    cy: 1.99993,
    rx: 1.99993,
    ry: 1.99993,
    fill: "#D9D9D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.99993,
    cy: 1.99993,
    rx: 1.99993,
    ry: 1.99993,
    fill: "#D9D9D9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99993,
    cy: 8.66674,
    rx: 1.99993,
    ry: 1.99993,
    fill: "#D9D9D9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.99993,
    cy: 8.6665,
    rx: 1.99993,
    ry: 1.99993,
    fill: "#D9D9D9"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99993,
    cy: 15.3338,
    rx: 1.99993,
    ry: 1.99993,
    fill: "#D9D9D9"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.99993,
    cy: 15.3339,
    rx: 1.99993,
    ry: 1.99993,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideCorner);
export default __webpack_public_path__ + "static/media/sideCorner.a5b9308a6f436002210522b4c9b7b3fd.svg";
export { ForwardRef as ReactComponent };